module.exports = __webpack_public_path__ + "static/media/Wishlist_orange.261391da.png";